export const FULFILLMENT_LOCATION_STH = 'DirectShip';
export const FULFILLMENT_METHOD_STH = 'ShipToHome';
export const FULFILLMENT_METHOD_BOSS = 'ShipToStore';
export const FULFILLMENT_METHOD_BOPIS = 'BOPIS';
export const FULFILLMENT_METHOD_BODFS = 'DeliverFromStore';
export const FULFILLMENT_METHOD_APPLIANCE = 'DirectDelivery';

export const ICONS = {
  tool: 'use-and-care-manual.svg',
  info: 'info.svg',
  hdpp: 'protection-plan.svg',
  proReferralIcon: 'pro-referral-svg.svg',
};
export const STATIC_ASSETS_PATH = 'https://assets.homedepot-static.com/images/v1/';

export const cartBinding = {
  ATTACH_LABOR: 'attach-labor',
  ATTACH_LABOR_STORE_ASSEMBLY: 'assembleItemAtStore',
  HDPP: 'hdpp',
  PRO_REFERRAL: 'pro-referral',
  PRO_ASSEMBLY: 'assembly',
  DUAL_PATH: 'dual-path',
  SAM_DUAL_PATH: 'sam-dual-path',
};

// ATTACH LABOR CONSTANTS

export const attachLaborType = {
  ASSEMBLY: 'assembly',
  INSTALL: 'install'
};

// DUAL PATH CONTACT INFORMATION

export const dualPathContactInformation = {
  brio_inaisle_sfi_whtr: {
    label: '1-855-400-2552',
    tel: '18554002552'
  }
};
